/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    var tabs = $('.wpmc-tab-item');
    var sections = $('.wpmc-step-item');
    var sections_step_infos = $('.checkout_info_step');
    var buttons = $('.wpmc-nav-buttons .button');
    var checkout_form = $('form.woocommerce-checkout');
    var coupon_form = $('#checkout_coupon');
    var loader_abcliv = $('#loader-abcliv');

    var button_next_label = ['', 'Etape 2 - 2/2 : choisir les services associés', 'Etape 3 - 1/2 : les informations de la société', 'Etape 3 - 2/2 : les informations concernant les responsables', 'Etape 4 : valider et passer au paiement', ''];
    var title_step_checkout = ['Sélectionnez votre adresse de domiciliation', 'Choisissez votre profil entrepreneurial', 'Ajoutez des services à votre domiciliation', 'Les informations concernant votre société', 'Les informations concernant les responsables de la société', 'Récapitulatif de votre domiciliation', 'Validation de votre contrat de domiciliation'];

    var required_inputs_info_step_1 = checkout_form.find('#checkout_info_step_1').find('.validate-required');

    $('.wpmc-step-item:first').addClass('current');
    $('.wpmc-step-item.current #checkout_info_step_1').addClass('current_info_step');

    var CHECK_OUT = {
        currentIndex: function () {
            return sections.index(sections.filter('.current'));
        },

        currentIndexStepInfos: function () {
            return sections_step_infos.index(sections_step_infos.filter('.current_info_step'));
        },

        loadDatasPage: function (loaded) {
            if (loaded) {
                loader_abcliv.removeClass('loading');
            } else {
                loader_abcliv.addClass('loading');
            }
        },

        is_in_cart: function (id_prod) {
            var in_cart = false;
            $('.adress-cart .cart-list-prod .prod').each(function () {
                if (id_prod === $(this).data('variation')) {
                    in_cart = true;
                }
            });
            return in_cart;
        },

        validate_company: function (name_company) {
            $.ajax({
                cache: true,
                type: 'post',
                dataType: 'json',
                url: wvgetAjax.ajaxurl,
                data: {
                    action: 'check_if_customerexist_bylegalname',
                    legalName: name_company,
                },
                success: function (response) {
                    if (response.result === 'success') {
                        $('.validate-company').removeClass('load-company');
                        if (response.message != '') {
                            $('#modal_alert_error .modal-content').addClass('modal-information');
                            $('#modal_alert_error .modal-body p').html(response.message.replace(/\n/g, '<br />'));
                            $('#modal_alert_error .modal-header .modal-title').html('Informations');
                            $('#modal_alert_error').modal('show');
                        }
                        if (response.customer_exist) {
                            $('#billing_company_field').removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                            $('#billing_company_field').removeClass('company-valid').addClass('company-novalid');
                        } else {
                            $('#billing_company_field').removeClass('company-novalid').addClass('company-valid');
                            $('#billing_company_field').removeClass('woocommerce-invalid woocommerce-invalid-required-field').addClass('company-valid woocommerce-validated');
                        }
                        return true;
                    }
                },
                error: function () {
                    console.log('error');
                },
            });
        },

        // Switch the tab
        switchTab: function (theIndex, theStep) {
            if (theIndex == 0) {
                // Si premier étape du checkout le click du bouton "Retour" renvoie vers le data-link du bouton
                window.location = $('#wpmc-prev').data('link');
                return false;
            }

            // scroll to top
            var diff = $('.wpmc-tabs-wrapper').offset().top - $(window).scrollTop();
            if (diff < -40) {
                $('html, body').animate(
                    {
                        scrollTop: $('.wpmc-tabs-wrapper').offset().top - 70,
                    },
                    800
                );
            }

            $('html, body')
                .promise()
                .done(function () {
                    switch (theIndex) {
                        case 1:
                            // Etape Informations Responsable
                            $('#wpmc-next').html(button_next_label[3]);
                            $('h2.title-checkout').html(title_step_checkout[3]);

                            var section_infos_step = sections_step_infos.filter('.current_info_step');
                            section_infos_step.removeClass('current_info_step', { duration: 500 });
                            sections_step_infos.eq(0).addClass('current_info_step', { duration: 500 });
                            break;

                        case -1:
                            //Etape Résumé commande + Paiement
                            console.log('Etape Résumé commande + Paiement');
                            $('#wpmc-next').html(button_next_label[4]);
                            $('h2.title-checkout').html(title_step_checkout[4]);

                            sections.removeClass('previous');
                            sections_step_infos.eq(1).removeClass('previous').addClass('current_info_step', { duration: 500 });
                            sections.removeClass('current', { duration: 500 });
                            sections.eq(0).addClass('current', { duration: 500 });
                            $('.sidebar-checkout aside.checkout-summary').addClass('current');
                            $('.sidebar-checkout aside.checkout-payment').removeClass('current');
                            $('#wpmc-next').addClass('current');

                            // Change the tab
                            tabs.removeClass('current', { duration: 500 });
                            tabs.removeClass('current').filter('.previous').addClass('current', { duration: 500 });

                            break;

                        case 4:
                            $('#wpmc-prev').addClass('current');
                            $('#wpmc-prev').html('Annuler');
                            $('#wpmc-submit').addClass('current');
                            $('#wpmc-next').removeClass('current');
                            checkout_form.removeClass('processing').unblock();

                            CHECK_OUT.loadDatasPage(true);

                            sections.removeClass('previous').filter('.current').addClass('previous');
                            sections.removeClass('current', { duration: 500 });
                            sections.eq(1).addClass('current', { duration: 500 });
                            $('.sidebar-checkout aside.checkout-summary').removeClass('current');
                            $('.sidebar-checkout aside.checkout-payment').addClass('current');
                            $('#wpmc-next').removeClass('current').hide();
                            $('h2.title-checkout').html(title_step_checkout[5]);
                            break;

                        default:
                            // Etape Infos Societé
                            tabs.removeClass('previous').filter('.current').addClass('previous');
                            // Change the tab
                            tabs.removeClass('current', { duration: 500 });
                            tabs.eq(theIndex).addClass('current', { duration: 500 });
                            break;
                    }

                    // Which buttons to show?
                    $('#wpmc-next').html(button_next_label[theStep]);
                    $('h2.title-checkout').html(title_step_checkout[theStep]);
                    coupon_form.hide();

                    // Show "previous" button
                    if (theIndex !== 0) {
                        $('#wpmc-prev').addClass('current');
                    }

                    if ($('.wpmc-order.current').length > 0) {
                        coupon_form.show();
                    }
                });
        },

        /**
         * Changement de section
         * @method
         * @memberof CHECK_OUT
         * @param {int} theIndex : index de la section en cours
         * @param {Bollean} stepBack : Retour à la section précédente (Bouton retour)
         */
        switchStepInfos: function (theIndex, stepBack) {
            console.log('switchStepInfos / theIndex :: ' + theIndex);

            if (stepBack) {
                if (theIndex < 0) {
                    window.location = $('#wpmc-prev').data('link');
                    return false;
                }
            }

            // Scroll to top
            var diff = $('.wpmc-tabs-wrapper').offset().top - $(window).scrollTop();
            if (diff < -40) {
                $('html, body').animate({ scrollTop: $('.wpmc-tabs-wrapper').offset().top - 70 }, 800);
            }

            $('html, body')
                .promise()
                .done(function () {
                    var infos_step_index = CHECK_OUT.currentIndexStepInfos();
                    var section_infos_step = sections_step_infos.filter('.current_info_step');

                    $('#billing_postcode').vicopo(function (cities) {
                        if (cities.length > 0) {
                            $('#billing_city').val(cities[0].city);
                        }
                    });
                    $('#person_in_chargee_0_postcode').vicopo(function (cities) {
                        if (cities.length > 0) {
                            $('#person_in_chargee_0_city').val(cities[0].city);
                        }
                    });

                    console.log('infos_step_index :: ' + infos_step_index);
                    console.log(section_infos_step);

                    if (!stepBack) {
                        if (CHECK_OUT.validate_field_step_infos(section_infos_step) || theIndex < infos_step_index) {
                            console.log(sections_step_infos.length);
                            console.log('validate_field_step_infos :: ' + theIndex);

                            section_infos_step.addClass('previous');
                            // Change the step infos
                            section_infos_step.removeClass('current_info_step', { duration: 500 });
                            sections_step_infos.eq(infos_step_index + 1).addClass('current_info_step', { duration: 500 });

                            if (theIndex === 0) {
                                $('#wpmc-next').data('step', infos_step_index + 1);
                            } else {
                                $('#wpmc-next').data('step', infos_step_index + 1);
                            }

                            //if ( theIndex !== 0 ) {$('#wpmc-prev').addClass('current');}

                            /*if ( theIndex === sections_step_infos.length) {
                      CHECK_OUT.switchTab(CHECK_OUT.currentIndex() + 1);
                  }*/
                            if (theIndex === 2) {
                                CHECK_OUT.switchTab(4, 5);
                            } else {
                                $('#wpmc-next').html(button_next_label[CHECK_OUT.currentIndex() + 4]);
                                $('h2.title-checkout').html(title_step_checkout[CHECK_OUT.currentIndex() + 4]);
                            }
                        }
                    } else {
                        if (infos_step_index == 2) {
                            CHECK_OUT.switchTab(0, 2);
                        } else {
                            section_infos_step.removeClass('previous');
                            // Change the step infos
                            section_infos_step.removeClass('current_info_step', { duration: 500 });
                            sections_step_infos.eq(theIndex).addClass('current_info_step', { duration: 500 });

                            $('#wpmc-next').html(button_next_label[CHECK_OUT.currentIndex() + 3]);
                            $('h2.title-checkout').html(title_step_checkout[CHECK_OUT.currentIndex() + 3]);

                            $('#wpmc-next').data('step', theIndex);
                        }
                    }
                });
        },

        validate_field_step_infos: function (section_step) {
            var $form_row = $(section_step).children('.form-row');
            var section_validated = true;

            $form_row.each(function () {
                var $this = $(this),
                    validated = true,
                    validate_required = $this.is('.validate-required'),
                    validate_company = $this.is('.validate-company'),
                    validate_email = $this.is('.validate-email'),
                    validate_email_confirm = $this.is('.validate-email-confirm'),
                    validate_select = $this.is('.validate-select'),
                    validate_date = $this.is('.validate-date'),
                    validate_phone = $this.is('.validate-phone'),
                    form_element = $this.find('.form-control');

                if (validate_required) {
                    if ('checkbox' === form_element.attr('type') && !form_element.is(':checked')) {
                        $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                        validated = false;
                    } else if (form_element.val() === '') {
                        $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                        validated = false;
                    } else if (form_element.data('minlength') !== undefined) {
                        if (form_element.val().length < form_element.data('minlength')) {
                            $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                            validated = false;
                        }
                    }
                }
                if (validate_company) {
                    if ($this.hasClass('company-valid')) {
                        validated = true;
                    } else {
                        validated = false;
                        $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                    }
                }

                if (validate_select) {
                    if (form_element.val() === '#') {
                        $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                        validated = false;
                    }
                } else if (validate_email) {
                    if (form_element.val()) {
                        /* https://stackoverflow.com/questions/2855865/jquery-validate-e-mail-address-regex */
                        var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);

                        if (!pattern.test(form_element.val())) {
                            $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email');
                            validated = false;
                        }

                        if ($(form_element.context.nextElementSibling).find("input[id$='confirm']").length > 0) {
                            if (form_element.val() !== $(form_element.context.nextElementSibling).find("input[id$='confirm']").val()) {
                                $(form_element.context.nextElementSibling).removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email');
                                validated = false;
                            }
                        }

                        if (form_element.attr('id') != 'billing_email' && form_element.val() == $('input[id="billing_email"]').val()) {
                            $this.addClass('woocommerce-invalid woocommerce-invalid-email');
                            validated = false;
                        }
                    }
                } else if (validate_email_confirm) {
                    if (form_element.val() !== $(form_element.context.previousElementSibling).find("input[id$='email']").val()) {
                        $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email');
                        validated = false;
                    }
                } else if (validate_date) {
                    if (form_element.val()) {
                        var dtRegex = new RegExp(/\b\d{2}[\/-]\d{2}[\/-]\d{4}\b/);
                        if (!dtRegex.test(form_element.val())) {
                            $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                            validated = false;
                        }
                    }
                } else if (validate_phone) {
                    if (form_element.val()) {
                        var chiffres_tel = form_element.val().replace(/[^0-9]/g, '');
                        var regex = new RegExp(/^(06|07)[0-9]{8}/gi);
                        if (!regex.test(chiffres_tel)) {
                            $this.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
                            validated = false;
                        }
                    }
                }

                if (validated) {
                    $this.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email').addClass('woocommerce-validated');
                } else {
                    section_validated = false;
                }
            });

            return section_validated;
        },
    };

    var listGmarkers = [];
    var listInfosWindows = [];

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        common: {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

                // Ajout des attribut sur le bouton "Me faire rappeler" pour afficher la popup
                $('.recall').attr('data-toggle', 'modal').attr('data-target', '#myModal');

                $('.recall').click(function (e) {
                    e.preventDefault();
                    $('#orContainer').show();
                });

                $('#contactAgenceBtn').click(function () {
                    $('#coordAgence').show();
                });

                $('#myModal').on('hidden.bs.modal', function () {
                    $('#coordAgence').hide();
                });

                /* On initialise le sélecteur de date et on le cache */
                $('.date-container').hide();
                $('#dateSelector').datepicker({
                    language: 'fr-FR',
                    autoPick: true,
                    autoHide: true,
                });

                /* On détecte les changement de valeurs des boutons radio */
                $('.modal input[name=horaire]').on('change', function () {
                    var val = $('input[name=horaire]:checked').val();
                    $('#coordAgence').hide();
                    if (val === 'autre') {
                        $('.date-container').show();
                    } else {
                        $('.date-container').hide();
                    }
                });

                var current_date = new Date();

                var options = {
                    now: current_date.getHours() + 1 + ' : 00', //hh:mm 24 hour format only, defaults to current time
                    twentyFour: true, //Display 24 hour format, defaults to false
                    upArrow: 'wickedpicker__controls__control-up', //The up arrow class selector to use, for custom CSS
                    downArrow: 'wickedpicker__controls__control-down', //The down arrow class selector to use, for custom CSS
                    close: 'wickedpicker__close', //The close class selector to use, for custom CSS
                    hoverState: 'hover-state', //The hover state class to use, for custom CSS
                    title: 'Sélectionnez un horaire', //The Wickedpicker's title,
                    showSeconds: false, //Whether or not to show seconds,
                    timeSeparator: ' : ', // The string to put in between hours and minutes (and seconds)
                    secondsInterval: 1, //Change interval for seconds, defaults to 1,
                    minutesInterval: 15, //Change interval for minutes, defaults to 1
                    beforeShow: null, //A function to be called before the Wickedpicker is shown
                    afterShow: null, //A function to be called after the Wickedpicker is closed/hidden
                    show: null, //A function to be called when the Wickedpicker is shown
                    clearable: false, //Make the picker's input clearable (has clickable "x")
                };

                $('.timepicker').wickedpicker(options);

                document.addEventListener(
                    'wpcf7mailsent',
                    function (event) {
                        if ('199' === event.detail.contactFormId) {
                            $('#orContainer').hide();
                        }
                    },
                    false
                );

                $('.clickable-row').click(function () {
                    window.location = $(this).data('href');
                });

                $('.js-scrollTo').on('click', function () {
                    // Au clic sur un élément
                    var page = $(this).attr('href'); // Page cible
                    var speed = 750; // Durée de l'animation (en ms)
                    $('html, body').animate({ scrollTop: $(page).offset().top }, speed); // Go
                    return false;
                });

                if ($('#loader-abcliv').length > 0) {
                    $('#loader-abcliv').height($(document).height());
                }

                // Quand le form de contact est soumis, scroller vers champs en erreur s'il y en a
                if ($('body.contact .text-content-page .wpcf7-form').length > 0) {
                    $(".wpcf7").on('invalid.wpcf7',function(e){
                        $('html, body').animate({
                                scrollTop: $(".wpcf7-not-valid").first().offset().top-60
                            }, 500);
                    });
                }

                // Sur mobile, déplacer le bouton de soumission
                if (window.innerWidth <= 560) {
                    $('#formulaire-responsive .wpcf7-submit').appendTo('#formulaire-responsive');
                }
            },
        },
        // Home page
        home: {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS

                /* On modifie le nombre de slide à afficher en fonction de la taille de l'écran */
                /* Fonctionne au rechargement de la page                                        */
                var srceen_width = $(window).width();
                var nb_slides_to_show = 4;

                if (srceen_width > 1000) {
                    nb_slides_to_show = 4;
                } else {
                    nb_slides_to_show = 1;
                }

                $('.center-slider').slick({
                    dots: false,
                    infinite: true,
                    centerMode: false,
                    slidesToShow: nb_slides_to_show,
                    slidesToScroll: 1,
                    draggable: false,
                    focusOnSelect: false,
                    cssEase: 'ease-out',
                    autoplay: true,
                    autoplaySpeed: 3000,
                });

                // Envoi d'un formulaire de domiciliation
                $('.wpcf7').submit(function (e) {
                    // On désactive le bouton submit le temps de l'envoi pour empecher les doublons
                    $(this).find('.wpcf7-submit').attr('disabled', true);
                });

                // On réactive les boutons submit une fois le formulaire envoyé
                document.addEventListener(
                    'wpcf7submit',
                    function (event) {
                        $('.wpcf7-submit').attr('disabled', false);
                    },
                    false
                );

                UTIL.init_map();
            },
        },
        post_type_archive_product: {
            init: function () {
                // JavaScript to be fired on the about us page
            },
            finalize: function () {
                console.log('nos-agences');
                UTIL.init_map();
            },
        },
        carte_domiciliation: {
            init: function () {
                // JavaScript to be fired on the about us page
            },
            finalize: function () {
                $('h2.title-checkout').html(title_step_checkout[0]);
                tabs.eq(0).addClass('current', { duration: 500 });
                UTIL.init_map();
            },
        },
        // About us page, note the change from about-us to about_us.
        about_us: {
            init: function () {
                // JavaScript to be fired on the about us page
            },
            finalize: function () {
                UTIL.init_map();
            },
        },
        checkout: {
            init: function () {
                // JavaScript to be fired on the about us page
                if (document.body.className.indexOf('woocommerce-order-received') >= 0) {
                    CHECK_OUT.switchTab(3, 4);
                } else {
                    CHECK_OUT.switchTab(2, 3);
                }
            },
            finalize: function () {
                UTIL.init_map_sidebar();

                // Préselection Checkbox "Il s'agit d'un transfert de siège" si produit "transfert" dans le panier
                if ($('.adress-cart .cart-list-prod .transfert').length > 0) {
                    $('input#seat_transfer[type=checkbox]').prop('checked', true);
                }

                // Popup Adresse de reexpedition
                $('#is_adress_reex').checkboxpicker({
                    offLabel: 'Non',
                    onLabel: 'Oui',
                });
                $('#is_adress_reex').change('click', function (e) {
                    if ($(this).is(':checked')) {
                        $('#modal_reex').modal('show');
                    } else {
                        $('#modal_reex').modal('hide');
                    }
                });
                $('#reex-submit').on('click', function (e) {
                    $('#modal_reex').modal('hide');
                });

                $('.validate-company .col-sm-3').append('<p></p>');

                //Initialisation Date Picker pour Début Domiciliation
                //https://fengyuanchen.github.io/datepicker
                var d = new Date();
                var month = d.getMonth() + 1;
                var day = d.getDate();
                var dateday = (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + d.getFullYear();
                /*$('#date_start_field .input-text.form-control').datepicker({        
            format: "dd/mm/yyyy",language: "fr-FR",orientation: "bottom auto", autoHide:true
        });*/
                var fullDate = new Date();
                var currentDate = ('0' + fullDate.getDate()).slice(-2) + '/' + ('0' + (fullDate.getMonth() + 1)).slice(-2) + '/' + fullDate.getFullYear();
                $('#date_start_field .input-text.form-control').val(currentDate.toString());
                $('#date_start_field .input-text.form-control').prop('disabled', true);

                $('#date_birthday.input-text.form-control').datepicker({
                    date: new Date(1978, 1, 1),
                    endDate: new Date(2001, 1, 1),
                    startView: 2,
                    format: 'dd/mm/yyyy',
                    language: 'fr-FR',
                    orientation: 'bottom auto',
                    autoHide: true,
                });

                $('input[id^="person_in_charge"][id$="birthday"]').datepicker({
                    date: new Date(1978, 1, 1),
                    endDate: new Date(2001, 1, 1),
                    startView: 2,
                    format: 'dd/mm/yyyy',
                    language: 'fr-FR',
                    orientation: 'bottom auto',
                    autoHide: true,
                });

                $('#billing_company').focusout(function () {
                    $('.validate-company').addClass('load-company');
                    $('.validate-company .col-sm-3 p').html('Veuillez patienter nous recherchons si le nom de votre société existe dans notre base de donnée...');
                    CHECK_OUT.validate_company($(this).val());
                });

                //
                $('#type_company').change(function () {
                    $.ajax({
                        cache: true,
                        type: 'post',
                        dataType: 'json',
                        url: wvgetAjax.ajaxurl,
                        data: {
                            action: 'get_list_reponsables_by_code',
                            code_forme_juridique: $(this).val(),
                        },
                        success: function (response) {
                            if (response.result == 'success') {
                                $('#wpmc-next.button-active.current').prop('disabled', false);

                                $("#checkout_info_step_3.checkout_info_step [id^='person_in_chargee_']").hide();
                                $('.title_person_in_charge').remove();

                                $('#checkout_info_step_2 .info_step_2').before("<h3 class='title_person_in_charge'>" + response.responsables[0].label + '</h3>');
                                $('#checkout_info_step_2  input.input-text').attr('data-type', response.responsables[0].code);
                                $('#checkout_info_step_2  input[name="billing_type_responsable"]').val(response.responsables[0].code);

                                response.responsables.shift();

                                if (response.responsables.length > 0) {
                                    $('#add_new_responsable').show();

                                    for (var i = 0; i < 1; i++) {
                                        $('#checkout_info_step_3  [id^="person_in_chargee_' + i + '"]')
                                            .first()
                                            .before("<h3 class='title_person_in_charge'>" + response.responsables[i].label + '</h3>');
                                        $('#checkout_info_step_3  [id^="person_in_chargee_' + i + '"]').attr('data-type', response.responsables[i].code);
                                        $('#checkout_info_step_3  [id^="person_in_chargee_' + i + '"]').css('display', 'flex');
                                        $('#checkout_info_step_3  [id="person_in_chargee_' + i + '_type_responsable"]').val(response.responsables[i].code);
                                    }
                                } else {
                                    $('#add_new_responsable').hide();
                                }
                            } else {
                                $('#wpmc-next.button-active.current').prop('disabled', true);

                                $('#modal_alert_error .modal-content').addClass('modal-information');
                                $('#modal_alert_error .modal-body p').html("Impossible de passer a l'étape suivante. Rechargez la page et réessayez.");
                                $('#modal_alert_error .modal-header .modal-title').html('Informations');
                                $('#modal_alert_error').modal('show');
                            }
                        },
                        error: function () {
                            $('#wpmc-next.button-active.current').prop('disabled', true);

                            $('#modal_alert_error .modal-content').addClass('modal-information');
                            $('#modal_alert_error .modal-body p').html("Impossible de passer a l'étape suivante. Rechargez la page et réessayez.");
                            $('#modal_alert_error .modal-header .modal-title').html('Informations');
                            $('#modal_alert_error').modal('show');
                        },
                    });
                });

                $('form.checkout #date_start').change(function () {
                    $('#review_domiciliation_start span').html('le ' + $('form.checkout #date_start').val());
                });

                // Click on "next step" button
                $('#wpmc-next').on('click', function () {
                    var step = $(this).data('step') != undefined ? $(this).data('step') : 0;

                    console.log('#wpmc-next data step ::' + step);

                    // Last section
                    var section_infos_step = sections_step_infos.filter('.current_info_step');
                    if ((step === 1 || step === 2) && CHECK_OUT.validate_field_step_infos(section_infos_step)) {
                        if (step === 2) {
                            $('input[name=billing_nb_person_in_charge]').val(1);
                        }

                        var formElement = $('form.checkout.woocommerce-checkout');
                        var formdatas = formElement.serializeArray();
                        formdatas.push({ name: 'action', value: 'create_new_order' });
                        CHECK_OUT.loadDatasPage(false);

                        $.ajax({
                            cache: true,
                            type: 'post',
                            dataType: 'json',
                            url: wvgetAjax.ajaxurl,
                            data: formdatas,
                            success: function (response) {
                                if (response.result === 'success') {
                                    CHECK_OUT.switchStepInfos(2);
                                    $('.review-adress-cart').html($('.cart-total').html());
                                    $('#checkout_services .btn.btn-back').html('Annuler');
                                } else {
                                    CHECK_OUT.loadDatasPage(true);
                                    $('#modal_alert_error .modal-body p').html(response.error.replace(/\n/g, '<br />'));
                                    $('#modal_alert_error').modal('show');
                                }
                            },
                            error: function (xhr, status, error) {
                                console.log(xhr);
                                console.log(status);
                                console.log(error);
                            },
                        });
                    } else {
                        CHECK_OUT.switchStepInfos(step);
                        $('.review-adress-cart').html($('.cart-total').html());
                    }
                });

                // Click on "previous" button
                $('button#wpmc-prev').on('click', function () {
                    //CHECK_OUT.switchTab(CHECK_OUT.currentIndexStepInfos());
                    CHECK_OUT.switchStepInfos(CHECK_OUT.currentIndexStepInfos() - 1, true);
                });

                // Click on "Ajouter un responsable" button
                $('#add_new_responsable a').on('click', function (e) {
                    //$('input[name=billing_nb_person_in_charge]').val(1);
                    CHECK_OUT.switchStepInfos(CHECK_OUT.currentIndexStepInfos(), false);
                });

                // After submit, switch tabs where the invalid fields are
                $(document).on('checkout_error', function () {
                    var section_class = $('.woocommerce-invalid-required-field').closest('.wpmc-step-item').attr('class');
                    $('.wpmc-step-item').each(function (i) {
                        if ($(this).attr('class') === section_class) {
                            //CHECK_OUT.switchTab(i);
                        }
                    });
                });

                // Compatibility with Super Socializer
                if ($('.the_champ_sharing_container').length > 0) {
                    $('.the_champ_sharing_container').insertAfter($(this).parent().find('#checkout_coupon'));
                }

                // Prevent form submission on Enter
                $('.woocommerce-checkout').keydown(function (e) {
                    if (e.which === 13) {
                        e.preventDefault();
                        return false;
                    }
                });

                // "Back to Cart" button
                $('#wpmc-back-to-cart').click(function () {
                    window.location.href = $(this).data('href');
                });
            },
        },

        checkout_profil_services: {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                CHECK_OUT.switchTab(1, 1);
                UTIL.init_map_sidebar();

                $('[data-toggle="popover"]').popover();

                $('input[name=adresse_profils]').click(function (e) {
                    $('#btn-valid-profil').removeClass('disabled');
                    $('#btn-valid-profil').prop('disabled', false);
                });

                $('#btn-valid-services').on('click', function (e) {
                    CHECK_OUT.loadDatasPage(false);
                });

                $('form#form_checkout_profil').submit(function (evt) {
                    if (!$('#btn-valid-profil').disabled) {
                        evt.preventDefault();
                        CHECK_OUT.loadDatasPage(false);

                        var profil = $('input[name=adresse_profils]:checked', this).val();
                        var typeformejuridique = $('input[name=adresse_profils]:checked', this).data('typeformejuridique');
                        var codeformejuridique = $('input[name=adresse_profils]:checked', this).data('codeformejuridique');

                        $.ajax({
                            cache: true,
                            type: 'post',
                            dataType: 'json',
                            url: wvgetAjax.ajaxurl,
                            data: {
                                action: 'add_adress_in_card',
                                id_adress_variation: profil,
                                typeformejuridique: typeformejuridique,
                                codeformejuridique: codeformejuridique,
                                id_adress: '',
                                is_home: false,
                            },
                            success: function (response) {
                                $('#adresse_price').data('regularprice', response.adress_price.display_regular_price);
                                $('.adress-service').hide();

                                if (response.result === 'success') {
                                    if (response.fragments) {
                                        UTIL.updateCart(response.fragments);
                                    }

                                    var products_service = $('body').find('.adress-service');
                                    var prod_service;

                                    var labelbtn = 'Etape 3 - 1/2 : les informations de ';
                                    console.log(typeformejuridique);
                                    switch (typeformejuridique) {
                                        case 'ass':
                                            labelbtn += "l'association";
                                            break;
                                        case 'aut':
                                            labelbtn += "l'auto-entreprise";
                                            break;
                                        case 'par':
                                            labelbtn = 'Etape 3 - 1/2 : Vos informations';
                                            break;
                                        default:
                                            labelbtn += 'la société';
                                            break;
                                    }

                                    $('#btn-valid-services').html(labelbtn);

                                    CHECK_OUT.loadDatasPage(true);

                                    $.each(response.services_datas, function (index, service) {
                                        prod_service = $('body').find('#' + service.product_slug);
                                        prod_service.parent().hide();
                                        prod_service.attr('data-variation', service.variation);

                                        if (CHECK_OUT.is_in_cart(service.variation)) {
                                            prod_service.hide();
                                            $('#btn-valid-services').removeClass('disabled');
                                            $('#no_services').prop('disabled', true);
                                        }

                                        prod_service.find('.img-service img').attr('src', service.picto_prod);
                                        prod_service.find('h3').html(service.product);
                                        prod_service.find('h3').next('p').html(service.desc_prod);

                                        if (Math.trunc(service.display_regular_price) !== Math.trunc(service.display_price)) {
                                            prod_service.find('.promo-service').css('visibility', 'show');
                                            prod_service.find('.price del span').html(service.display_regular_price + '<span class="woocommerce-Price-currencySymbol">€</span><sup>HT</sup>/mois');
                                            prod_service.find('.price del').css('visibility', 'show');
                                            prod_service.find('.price ins span').html('<strong>' + service.display_price + '</strong><span class="woocommerce-Price-currencySymbol">€</span><sup>HT</sup>/mois<br/> les 6 premiers mois');
                                        } else {
                                            prod_service.find('.promo-service').css('visibility', 'hidden');
                                            prod_service.find('.promo-service').html('');
                                            prod_service.find('.price del').css('visibility', 'hidden');
                                            prod_service.find('.price del').html('');
                                            prod_service.find('.price ins span').html('<strong>' + service.display_price + '</strong><span class="woocommerce-Price-currencySymbol">€</span><sup>HT</sup>/mois<br/>');
                                        }

                                        prod_service.parent().show();

                                        $('#checkout_profil').hide();
                                        $('.adress-cart-init').hide();
                                        $('.adress-cart').show();
                                        $('.checkout-summary').removeClass('cart-empty');

                                        CHECK_OUT.switchTab(1, 2);

                                        $('#checkout_services .btn.btn-back').click(function (e) {
                                            $('#checkout_services').hide();
                                            $('#checkout_profil').show();
                                        });
                                        $('#checkout_services').show();

                                        CHECK_OUT.loadDatasPage(true);
                                    });
                                } else if (response.result === 'success_nochange') {
                                    CHECK_OUT.switchTab(1, 2);
                                    $('#checkout_profil').hide();
                                    $('#checkout_services').show();
                                }
                            },
                            error: function () {
                                CHECK_OUT.loadDatasPage(true);
                                console.log('error');
                            },
                        });
                    }
                });

                $('.adress-service .btn-addtocart').click(function (e) {
                    e.preventDefault();

                    CHECK_OUT.loadDatasPage(false);

                    var id_service = $(this).parent().parent().data('product');
                    var id_variation = $(this).parent().parent().data('variation');
                    var code_service = $(this).parent().parent().attr('id');
                    var that = $(this).parent().parent();
                    var animationEndEvent = UTIL.animationEnd();

                    $.ajax({
                        cache: true,
                        type: 'post',
                        dataType: 'json',
                        url: wvgetAjax.ajaxurl,
                        data: {
                            action: 'add_service_in_card',
                            id_service_variation: id_variation,
                            id_service: id_service,
                            code_service: code_service,
                        },
                        success: function (response) {
                            console.log(response);

                            if (response.result === 'success' && response.fragments) {
                                UTIL.updateCart(response.fragments);
                                //UTIL.initRemoveProdBtn();
                                that.removeClass('flipInX')
                                    .addClass('flipOutX')
                                    .one(animationEndEvent, function () {
                                        $(this).hide();
                                        $('#btn-valid-services').removeClass('disabled');
                                        $('#no_services').prop('disabled', true);
                                    });

                                CHECK_OUT.loadDatasPage(true);
                            }
                        },
                        error: function () {
                            console.log('error');
                        },
                    });
                });

                $('#no_services').click(function () {
                    if ($(this).is(':checked')) {
                        $('#btn-valid-services').removeClass('disabled');
                    } else if (!UTIL.oneServiceIsSelected()) {
                        $('#btn-valid-services').addClass('disabled');
                        $('#no_services').prop('disabled', false);
                    }
                });

                UTIL.initRemoveProdBtn();
            },
        },
        single_product: {
            init: function () {
                // Retourne le type d'entreprise sélectionné
                function getSelectedType() {
                    return $('.type-entreprise-list .type-entreprise-item.is-selected').data('type');
                }

                // Change les tarifs en fonction du type d'entreprise sélectionné
                function updateTarif() {
                    var type_entreprise = getSelectedType();

                    $('.js-tarif-mensuel-valeur').fadeTo('fast', 0);
                    $('.js-tarif-mensuel-reduc-valeur').fadeTo('fast', 0);

                    $('.js-tarif-mensuel-valeur').text(entreprises_infos[type_entreprise]['price_ht_month'] + ' €');
                    $('.js-tarif-mensuel-reduc-valeur').text(entreprises_infos[type_entreprise]['price_ht_month_reduc'] + ' €');

                    $('.js-tarif-mensuel-valeur').fadeTo('fast', 1);
                    $('.js-tarif-mensuel-reduc-valeur').fadeTo('fast', 1);
                }

                // Met à jour les serices en fonction du type d'entreprise sélectionné
                function updateService() {
                    var type_entreprise = getSelectedType();

                    $('.agence-services .agence-services-list').html('');

                    $.each(entreprises_infos[type_entreprise]['services'], function (key, value) {
                        $('.agence-services .agence-services-list').append('<div class="agence-service-item"><div class="service-icon-container"><img src="' + value.icon_url + '" alt="" class="service-icon"></div><p class="service-title">' + value.label + '</p><p class="service-tarif"><i class="fa fa-plus" aria-hidden="true"></i> ' + value.price_ht + ' € <sup>HT&nbsp;/&nbsp;Mois</sup></p></div>');
                    });
                }

                // Ajoute la class 'is-selected' au type d'entreprise sélectionné par l'utilisateur
                $('.type-entreprise-list .type-entreprise-item').on('click', function () {
                    if ($(this).hasClass('is-selected') == false) {
                        $('.type-entreprise-list .type-entreprise-item').removeClass('is-selected');
                        $(this).addClass('is-selected');

                        updateTarif();
                        updateService();
                    }
                });

                $('.js-display-tel').on('click', function () {
                    var tel = $(this).data('tel');

                    $(this).text(tel);
                });
            },
            finalize: function () {
                $('form.form_tarifs_agence').on('submit', function (evt) {
                    evt.stopPropagation();
                    var id_adress = $('input[name=id_agence]').val();

                    $.ajax({
                        cache: true,
                        type: 'post',
                        dataType: 'json',
                        url: wvgetAjax.ajaxurl,
                        data: {
                            action: 'add_adress_in_card',
                            id_adress: id_adress,
                            is_home: true,
                        },
                        success: function (response) {
                            //console.log("success");
                            window.location.href = response.url_next_step;
                        },
                        error: function () {
                            //console.log("error");
                        },
                    });
                    return false;
                });
            },
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = funcname === undefined ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        },
        arrayIntersect: function (a, b) {
            return $.grep(a, function (i) {
                return $.inArray(i, b) > -1;
            });
        },
        processPointsMap: function (geometry, callback, thisArg) {
            if (geometry instanceof google.maps.LatLng) {
                callback.call(thisArg, geometry);
            } else if (geometry instanceof google.maps.Data.Point) {
                callback.call(thisArg, geometry.get());
            } else {
                geometry.getArray().forEach(function (g) {
                    UTIL.processPointsMap(g, callback, thisArg);
                });
            }
        },
        initZoomControl: function (controlDiv, map) {
            // Creating divs & styles for custom zoom control
            controlDiv.style.padding = '5px';

            // Set CSS for the control wrapper
            var controlWrapper = document.createElement('div');
            controlWrapper.className = 'widgetmap_zoom';

            controlWrapper.style.cursor = 'pointer';
            controlWrapper.style.width = '50px';
            controlWrapper.style.height = '96px';
            controlDiv.appendChild(controlWrapper);

            // Set CSS for the zoomIn
            var zoomInButton = document.createElement('div');
            zoomInButton.innerHTML = '+';
            controlWrapper.appendChild(zoomInButton);

            // Set CSS for the zoomOut
            var zoomOutButton = document.createElement('div');
            zoomOutButton.innerHTML = '-';
            controlWrapper.appendChild(zoomOutButton);

            // Setup the click event listener - zoomIn
            google.maps.event.addDomListener(zoomInButton, 'click', function () {
                map.setZoom(map.getZoom() + 1);
            });

            // Setup the click event listener - zoomOut
            google.maps.event.addDomListener(zoomOutButton, 'click', function () {
                map.setZoom(map.getZoom() - 1);
            });
        },

        uniqueArrayValue: function (list) {
            var result = [];
            $.each(list, function (i, e) {
                if ($.inArray(e, result) === -1) {
                    result.push(e);
                }
            });
            return result;
        },

        /*filterMarkerMap: function(){
  
          var chkArray = [];
  
          $("#control_marker_map input:checkbox:checked").each(function() {
            chkArray.push($(this).val());
          });
  
          console.log(chkArray.length);
          for (i = 0; i < listGmarkers.length; i++) {
            marker = listGmarkers[i];
  
            if (UTIL.compareArrays(marker.category, chkArray) || $.inArray( chkArray.toString(), marker.category) >=0 || chkArray.length===0) {
                marker.setVisible(true);
            }
            // Categories don't match 
            else {
                marker.setVisible(false);
            }
          }
      },*/

        compareArrays: function (arr1, arr2) {
            return $(arr1).not(arr2).length === 0 && $(arr2).not(arr1).length === 0;
        },

        updateCart: function (fragments) {
            //console.log(fragments);
            $.each(fragments, function (key, value) {
                $(key).html(value);
            });
            UTIL.initRemoveProdBtn();
        },
        oneServiceIsSelected: function () {
            var service_hide = false;
            console.log($('.adress-service:hidden'));
            $('.adress-service .adress-service-content:hidden').each(function () {
                service_hide = true;
            });
            return service_hide;
        },
        initRemoveProdBtn: function () {
            var animationEndEvent = UTIL.animationEnd();

            $('.adress-cart .remove-prod a').click(function (e) {
                e.preventDefault();

                var that = $(this).parent().parent().parent();
                var id_variation = that.data('variation');
                var id_prod = that.attr('id');
                var cart_key = that.data('key');

                $.ajax({
                    cache: true,
                    type: 'post',
                    dataType: 'json',
                    url: wvgetAjax.ajaxurl,
                    data: {
                        action: 'remove_service_from_card',
                        id_service_variation: id_variation,
                        cart_key: cart_key,
                    },
                    success: function (response) {
                        if (response.result === 'success') {
                            UTIL.updateCart(response.fragments);

                            //that.removeClass("flipInX").addClass("flipOutX").one(animationEndEvent, function() {
                            $(this).hide();

                            //$(".list_services").find("[data-variation='" + id_variation + "']").show();
                            //$(".list_services").find("[data-variation='" + id_variation + "']").removeClass("flipOutX").addClass("flipInX");
                            console.log(id_prod);

                            $('.list_services')
                                .find('#' + id_prod)
                                .show();
                            $('.list_services')
                                .find('#' + id_prod)
                                .removeClass('flipOutX')
                                .addClass('flipInX');
                            if (!UTIL.oneServiceIsSelected()) {
                                $('#no_services').prop('disabled', false);
                                $('#btn-valid-services').addClass('disabled');
                            }

                            //});
                        }
                    },
                    error: function () {
                        console.log('error');
                    },
                });
            });
        },

        animationEnd: function () {
            var t,
                el = document.createElement('fakeelement');

            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'animationend',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        },

        init_map: function () {
            // Gestion de la map
            // https://www.shatimes.com/tuto-google-map-api-v3/
            //http://caseyy.org/blog/adding-a-custom-snazzy-map-to-wordpress
            var map;
            var latLng = new google.maps.LatLng(48.866667, 2.333333); // Correspond au coordonnées de Paris
            var styleMap = [
                { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] },
                { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] },
                { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
                { featureType: 'administrative', elementType: 'geometry.fill', stylers: [{ color: '#fefefe' }, { lightness: 20 }] },
                { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }] },
                { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 20 }] },
                { featureType: 'landscape.natural.landcover', elementType: 'geometry.stroke', stylers: [{ visibility: 'off' }] },
                { featureType: 'landscape.natural.terrain', elementType: 'all', stylers: [{ color: '#ff0000' }] },
                { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 21 }] },
                { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dedede' }, { lightness: 21 }] },
                { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] },
                { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }] },
                { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 18 }] },
                { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 16 }] },
                { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }, { lightness: 19 }] },
                { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#bcbcbc' }, { lightness: 17 }] },
            ];
            var mapargs = {
                zoom: 13,
                center: latLng,
                mapTypeId: google.maps.MapTypeId.ROADMAP, // Type de carte, différentes valeurs possible HYBRID, ROADMAP, SATELLITE, TERRAIN
                //maxZoom   : 30,
                disableDefaultUI: true /* Disabling default UI widgets */,
                styles: styleMap,
            };

            map = new google.maps.Map(document.getElementById('map'), mapargs);

            map.data.loadGeoJson(options_jscript.zoneparis);
            map.data.setStyle(function (feature) {
                return {
                    fillColor: '#f19637',
                    fillOpacity: 0.1,
                    strokeWeight: 1,
                    strokeColor: '#f19637',
                };
            });

            var zoomControlDiv = document.createElement('div');
            UTIL.initZoomControl(zoomControlDiv, map);
            zoomControlDiv.index = 1;
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomControlDiv);

            var listCategory = [];
            var image_marker = {
                url: options_jscript.dir_script + '/dist/images/img_marker.png',
                size: new google.maps.Size(16, 15),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(6, 15),
            };

            var $markers = $('.list-markers .marker');
            if ($markers.length > 0) {
                // add a markers reference
                map.markers = [];
                // add markers
                $markers.each(function () {
                    UTIL.add_map_marker($(this), map);
                });

                $('.check-prod').on('click', UTIL.filterMarkerMap);
                $('.check-cat').on('click', UTIL.filterMarkerMap);

                //console.log(map.markers);
                // Add a marker clusterer to manage the markers.
                /*var clusterStyles = [
                {
                  textColor: 'white',
                  url: UTIL.getRootUrl()+'gp/web/app/themes/swisslife/dist/images/smallclusterimage.png',
                  height: 50,
                  width: 50
                },
               {
                  textColor: 'white',
                  url: UTIL.getRootUrl()+'gp/web/app/themes/swisslife/dist/images/mediumclusterimage.png',
                  height: 50,
                  width: 50
                },
               {
                  textColor: 'white',
                  url: UTIL.getRootUrl()+'gp/web/app/themes/swisslife/dist/images/largeclusterimage.png',
                  height: 50,
                  width: 50
                }
              ];
              var mcOptions = {
                  gridSize: 17,
                  styles: clusterStyles,
                  ignoreHidden: true
                  //maxZoom: 9
              };
              markerCluster = new MarkerClusterer(map, map.markers,mcOptions);*/
            }

            //Import Markers
            /*$.getJSON(options_jscript.listmarkers, function(data) { 
              $.each( data.features, function(i, value) {
                  var coordinates = value.geometry.coordinates;
                  var properties = value.properties;
                  var markerLatlng = new google.maps.LatLng(coordinates[1], coordinates[0]);
                  var marker = new google.maps.Marker({
                      position: markerLatlng,
                      animation: google.maps.Animation,
                      map: map,
                      icon: image_marker,
                      title: properties.nom_du_cafe,
                      category: properties.type,
                  });
  
                  listGmarkers.push(marker);
                  $.each(properties.type, function(i, _cat) {
                    listCategory.push(_cat);
                  });
  
                  //Attach click event to the marker.
                  (function (marker, properties) {
                      google.maps.event.addListener(marker, "click", function (e) {
                          //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
                          map.panTo(this.getPosition());
                          infoWindow.setContent(
                          "<div class='window-marker'>"+
                          "<div class='photo_marker'><img src='"+properties.photo+"' /></div>"+
                          properties.adresse + "<br/>"+
                          properties.arrondissement+" "+properties.ville+
                          "<button class='btn' type='button' data-idadress='"+properties.id+"'>Je me domicilie à cette adresse</button>"+
                          "</div>"
                          );
  
                          infoWindow.open(map, marker);
  
                          $(".window-marker button").on('click', function(evt){ 
                            
                            evt.stopPropagation();
                            var id_adress =  $(this).data( "idadress" );
                            var is_home = $('body').hasClass('home');
  
                            $.ajax({
                                cache: true,
                                type: "post",
                                dataType: "json",
                                url: wvgetAjax.ajaxurl,
                                data: {
                                  "action": "add_adress_in_card",
                                  "id_adress": id_adress,
                                  "is_home": is_home
                                },
                                success: function (response) {
                                  console.log("success");
                                  console.log(response.url_next_step);
                                  document.location.href=response.url_next_step;
                                },
                                error: function () {
                                  console.log("error");
                                }
                            });
                              
  
                          });
                      });
                  })(marker, properties);
            });
  
              listCategory = UTIL.uniqueArrayValue(listCategory);
  
  
              $.each(listCategory, function(k, cat) {
                var cat_normalize = cat.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/ /g, '_').replace(/'/g, '').toLowerCase();
                var $div_check = $('<div>').addClass("form-check");
                var $radio_cat = $('<input/>').attr({ type: 'checkbox', name:'category_adress',value:cat, id:cat_normalize}).addClass("rad");
                $div_check.append($radio_cat);
                var $label_cat = $('<label>').attr({ for: cat_normalize}).text(cat);
                $div_check.append($label_cat);
                $("#control_marker_map form").append($div_check);
  
                $radio_cat.on('click', UTIL.filterMarkerMap);
              });
          });*/

            map.data.addListener('click', function (evt) {
                //current_infowindow.close();
                if (evt.feature.getGeometry().getType() === 'Polygon') {
                    //console.log(evt.feature.getProperty('c_ar'));
                    var bounds = new google.maps.LatLngBounds();
                    UTIL.processPointsMap(evt.feature.getGeometry(), bounds.extend, bounds);
                    map.fitBounds(bounds);
                }
            });

            $('#reset_control_marker_map').on('click', function (evt) {
                evt.preventDefault();
                $('#control_marker_map input:checkbox').removeAttr('checked');
                UTIL.filterMarkerMap();
            });
        },

        init_map_sidebar: function () {
            // Gestion de la map en sidebar
            // https://www.shatimes.com/tuto-google-map-api-v3/
            //http://caseyy.org/blog/adding-a-custom-snazzy-map-to-wordpress
            var map;
            var marker = $('#contenair-map .marker');
            var latLng = new google.maps.LatLng(marker.attr('data-lat'), marker.attr('data-lng')); // Correspond au coordonnées de Paris
            var styleMap = [
                { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] },
                { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] },
                { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
                { featureType: 'administrative', elementType: 'geometry.fill', stylers: [{ color: '#fefefe' }, { lightness: 20 }] },
                { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }] },
                { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 20 }] },
                { featureType: 'landscape.natural.landcover', elementType: 'geometry.stroke', stylers: [{ visibility: 'off' }] },
                { featureType: 'landscape.natural.terrain', elementType: 'all', stylers: [{ color: '#ff0000' }] },
                { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 21 }] },
                { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dedede' }, { lightness: 21 }] },
                { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] },
                { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }] },
                { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 18 }] },
                { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 16 }] },
                { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }, { lightness: 19 }] },
                { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#bcbcbc' }, { lightness: 17 }] },
            ];
            var mapargs = {
                zoom: 16,
                center: latLng,
                mapTypeId: google.maps.MapTypeId.ROADMAP, // Type de carte, différentes valeurs possible HYBRID, ROADMAP, SATELLITE, TERRAIN
                //maxZoom   : 30,
                disableDefaultUI: true /* Disabling default UI widgets */,
                styles: styleMap,
            };

            map = new google.maps.Map(document.getElementById('map-adress'), mapargs);
            map.data.setStyle(function (feature) {
                return {
                    fillColor: '#f19637',
                    fillOpacity: 0.1,
                    strokeWeight: 1,
                    strokeColor: '#f19637',
                };
            });

            var image_marker = {
                url: options_jscript.dir_script + '/dist/images/img_marker_big.png',
                size: new google.maps.Size(30, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(14, 20),
            };

            map.markers = [];
            if (marker.length > 0) {
                UTIL.add_map_marker(marker, map, image_marker);
            }
        },

        add_map_marker: function ($marker, $map, $image_marker) {
            //console.log($marker);
            var current_infowindow;
            var image_marker = $image_marker || {
                url: options_jscript.dir_script + '/dist/images/img_marker.png',
                size: new google.maps.Size(16, 15),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(6, 15),
            };

            var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
            var cat = $marker.attr('data-cat');
            var link = $marker.attr('data-link');
            var type = $marker.attr('data-type');

            // create marker
            var marker = new google.maps.Marker({
                position: latlng,
                animation: google.maps.Animation,
                map: $map,
                icon: image_marker,
                category: cat,
                type: type,
                link: link,
            });
            // add to array
            $map.markers.push(marker);
            listGmarkers.push(marker);

            // if marker contains HTML, add it to an infoWindow
            if ($marker.html()) {
                // create info window
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html(),
                    maxWidth: 320,
                });
                listInfosWindows.push(infowindow);
                //current_infowindow = infowindow;

                // show info window when marker is clicked
                google.maps.event.addListener(marker, 'mouseover', function () {
                    UTIL.hideAllInfoWindows();
                    //current_infowindow = infowindow;

                    infowindow.open($map, marker);
                });

                google.maps.event.addListener(marker, 'mouseout', function () {
                    //infowindow.close();
                });
                google.maps.event.addListener(marker, 'click', function (evt) {
                    evt.stopPropagation();
                    //window.location.href = marker.link;
                });

                //http://en.marnoto.com/2014/09/5-formas-de-personalizar-infowindow.html
                google.maps.event.addListener(infowindow, 'domready', function () {
                    $('.window-marker a.btn').on('click', function (evt) {
                        evt.stopPropagation();
                        var loader_map_abcliv = $('#loader-map-abcliv');
                        loader_map_abcliv.addClass('loading');
                        var id_adress = $(this).data('idadress');
                        var is_home = $('body').hasClass('home');

                        $.ajax({
                            cache: true,
                            type: 'post',
                            dataType: 'json',
                            url: wvgetAjax.ajaxurl,
                            data: {
                                action: 'add_adress_in_card',
                                id_adress: id_adress,
                                is_home: is_home,
                            },
                            success: function (response) {
                                console.log('success');
                                //console.log(response.url_next_step);
                                var marker = $('#' + id_adress);

                                window.dataLayer.push({
                                    event: 'enhancedEcommerce',
                                    eventCategory: 'enhanced Ecommerce',
                                    eventAction: 'Impression Fiche Produit + Ajout Panier',
                                    eventLabel: '[produit1Nom]/[Arrondissement]', // Nom de l'adresse choisie ou Service + Arrondissement du logement choisi
                                    eventValue: undefined, // Il s'agit bien d'une réinitialisation de la variable, pas de la chaîne "undefined"
                                    ecommerce: {
                                        click: {
                                            actionField: { list: '[type de liste]' }, // Indiquer la liste : 'list':'homepage' ou 'list':'service'
                                            products: [
                                                {
                                                    name: '[produit1Nom]', // Nom de l'adresse choisie ou du service
                                                    id: '[produit1Id]', // ID unique
                                                    price: '[produit1Prix]', // Prix unitaire HT
                                                    category: marker.data('cat'), // Caractéristiques : prestigieuse / avec salle de réunion / premier prix / près d'une gare etc.
                                                    brand: '[Arrondissement]', // Arrondissement du logement choisi
                                                    variant: marker.data('type'), // Profil adresse : societe, association, auto entrepreneur ,particulier ou undefined si aucune valeur
                                                    quantity: 1,
                                                    position: 1, // Position du produit correspondant au clic dans la liste de produit
                                                },
                                            ],
                                        },
                                        currencyCode: 'EUR',
                                        add: {
                                            products: [
                                                {
                                                    name: '[produit1Nom]', // Nom de l'adresse choisie ou du service
                                                    id: '[produit1Id]', // ID unique
                                                    price: '[produit1Prix]', // Prix unitaire HT
                                                    category: '[caractéristiques-adresse]', // Caractéristiques : prestigieuse / avec salle de réunion / premier prix / près d'une gare etc.
                                                    brand: '[Arrondissement]', // Arrondissement du logement choisi
                                                    variant: '[profil adresse]', // Profil adresse : societe, association, auto entrepreneur ,particulier ou undefined si aucune valeur
                                                    quantity: 1, // La quantité commandée (par défaut 1)
                                                },
                                            ],
                                        },
                                    },
                                });

                                window.location.href = response.url_next_step;
                            },
                            error: function () {
                                loader_map_abcliv.removeClass('loading');
                                console.log('error');
                            },
                        });

                        return false;
                    });
                });
            }

            return marker;
        },
        hideAllInfoWindows: function () {
            listInfosWindows.forEach(function (infowindow) {
                infowindow.close();
            });
        },
        filterMarkerMap: function () {
            var chkprodArray = [];
            var chkcatArray = [];
            var markerInCluster = [];
            var aMarkerCategory = [];

            $('#control_marker_map input.check-prod:checkbox:checked').each(function () {
                chkprodArray.push($(this).val());
            });

            $('#control_marker_map input.check-cat:checkbox:checked').each(function () {
                chkcatArray.push($(this).val());
            });

            //console.log(listGmarkers.length);

            for (i = 0; i < listGmarkers.length; i++) {
                marker = listGmarkers[i];

                if (chkprodArray.length > 0 && chkcatArray.length > 0) {
                    aMarkerCategory = marker.category.split(',');
                    aMarkerType = marker.type.split(',');

                    if (UTIL.arrayIntersect(aMarkerType, chkprodArray).length == chkprodArray.length && UTIL.arrayIntersect(aMarkerCategory, chkcatArray).length == chkcatArray.length) {
                        marker.setVisible(true);
                    } else {
                        marker.setVisible(false);
                    }
                } else if (chkprodArray.length > 0 || chkcatArray.length > 0) {
                    aMarkerCategory = marker.category.split(',');
                    aMarkerType = marker.type.split(',');
                    if ((UTIL.arrayIntersect(aMarkerType, chkprodArray).length > 0 && UTIL.arrayIntersect(aMarkerType, chkprodArray).length == chkprodArray.length) || (UTIL.arrayIntersect(aMarkerCategory, chkcatArray).length > 0 && UTIL.arrayIntersect(aMarkerCategory, chkcatArray).length == chkcatArray.length)) {
                        marker.setVisible(true);
                    } else {
                        marker.setVisible(false);
                    }
                } else if (chkprodArray.length === 0 && chkcatArray.length === 0) {
                    marker.setVisible(true);
                } else {
                    marker.setVisible(false);
                }
            }
        },
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
